import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from "@angular/common/http";
import { AppLoadService } from './service/app-load.service';

export function load_settings(appLoadService: AppLoadService) {
    return () => appLoadService.loadSettings();
}

@NgModule({
  imports: [HttpClientModule],
  providers: [
    AppLoadService,
    { provide: APP_INITIALIZER, useFactory: load_settings, deps: [AppLoadService], multi: true }
  ]
})
export class AppLoadModule { }